import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Volume2, VolumeX } from "lucide-react";

export const Intro = ({ onDone }) => {
  const [visible, setVisible] = useState(true);
  const [muted, setMuted] = useState(true);
  const videoRef = useRef(null);
  const finished = useRef(false);

  const finish = () => {
    if (finished.current) return;
    finished.current = true;
    setVisible(false);
    setTimeout(onDone, 850);
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    window.__lenis?.stop();
    const maxTimer = setTimeout(finish, 9000);
    return () => {
      clearTimeout(maxTimer);
      document.body.style.overflow = "";
      window.__lenis?.start();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="intro-splash"
          className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-deep"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.85, ease: [0.76, 0, 0.24, 1] }}
        >
          <div className="blueprint-grid-dark pointer-events-none absolute inset-0" />
          <motion.video
            ref={videoRef}
            data-testid="intro-logo-video"
            autoPlay
            muted={muted}
            playsInline
            onEnded={finish}
            onError={finish}
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
            className="relative max-h-[70vh] w-auto max-w-[85vw] border border-white/15 object-contain"
            style={{ boxShadow: "8px 8px 0 0 #0055FF" }}
          >
            <source src="/logo-video.webm" type="video/webm" />
            <source src="/logo-video.mp4" type="video/mp4" onError={finish} />
          </motion.video>
          <button
            data-testid="intro-sound-toggle"
            onClick={() => setMuted((m) => !m)}
            className="absolute bottom-8 left-8 flex items-center gap-2 border border-white/30 px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.2em] text-white/80 transition-colors hover:border-electric hover:bg-electric hover:text-white"
          >
            {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
            {muted ? "Sound Off" : "Sound On"}
          </button>
          <button
            data-testid="intro-skip-button"
            onClick={finish}
            className="absolute bottom-8 right-8 border border-white/30 px-5 py-2.5 font-mono text-xs font-bold uppercase tracking-[0.2em] text-white/80 transition-colors hover:border-electric hover:bg-electric hover:text-white"
          >
            Skip
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
